module.exports = __webpack_public_path__ + "static/media/Raleway-ThinItalic.8fe060be.ttf";